import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.href ? `https://www.guifu2-analysis.com${item.href}` : undefined,
    })),
  };

  return (
    <>
      <nav aria-label="Breadcrumb" className="w-full px-4 md:px-6 py-3">
        <ol className="flex items-center flex-wrap gap-1.5 text-sm">
          {items.map((item, index) => {
            const isLast = index === items.length - 1;
            return (
              <li key={index} className="flex items-center gap-1.5">
                {index > 0 && (
                  <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
                )}
                {!isLast && item.href ? (
                  <Link
                    to={item.href}
                    className="text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </Link>
                ) : (
                  <span className={isLast ? 'text-foreground-800 font-medium' : 'text-foreground-500'}>
                    {item.label}
                  </span>
                )}
              </li>
            );
          })}
        </ol>
      </nav>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
    </>
  );
}

export function getCategoryBreadcrumb(categorySlug: string) {
  const cat = categories.find((c) => c.slug === categorySlug);
  return [
    { label: '首页', href: '/' },
    { label: cat?.name || '分类', href: `/category/${categorySlug}` },
  ];
}

export function getArticleBreadcrumb(categorySlug: string, articleSlug: string) {
  const cat = categories.find((c) => c.slug === categorySlug);
  return [
    { label: '首页', href: '/' },
    { label: cat?.name || '分类', href: `/category/${categorySlug}` },
    { label: '文章详情' },
  ];
}